import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {View} from 'react-native';

import {apiUpdateUserBadges} from 'src/Utils/apiCalls';

/////////////////////////////////////////////
///////  components

import {TopTab, TopTabButton} from 'src/Modules/TabViews';

import Shop from 'src/Backpack/Shop';
import Profile from 'src/Backpack/Profile';
import PastHunts from 'src/Backpack/PastHunts';
import CallSupportLine from 'src/HeaderComponents/CallSupportLine';

import useParams from 'src/Hooks/useParams';
import {useUserId} from 'src/Hooks/reduxHooks';

const Backpack = () => {
  const userId = useUserId();
  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const {view: initialView = 'shop'} = useParams();
  const [view, setView] = useState(initialView);

  useEffect(() => {
    if (!!userId) {
      apiUpdateUserBadges(userId);
    }
  }, []);

  console.log('the active view is ', {view});

  return (
    <View style={{flex: 1, backgroundColor: global?.color?.white}}>
      <CallSupportLine />
      <TopTab>
        {!playTestState && (
          <TopTabButton
            text={'Shop'}
            active={view === 'shop'}
            handlePress={() => {
              setView('shop');
            }}
          />
        )}
        <TopTabButton
          text={'Profile'}
          active={view === 'profile'}
          handlePress={() => {
            setView('profile');
          }}
        />
        {
          <TopTabButton
            text={'Past Hunts'}
            active={view === 'hunts'}
            handlePress={() => {
              setView('hunts');
            }}
          />
        }
      </TopTab>
      <View
        style={{
          flex: 1,
          position: 'relative',
          backgroundColor: global?.color?.white1,
        }}>
        {view === 'shop' && !playTestState && (
          <Shop
            navigateToPage={(page) => {
              setView(page || 'profile');
            }}
          />
        )}
        {(view === 'profile' || !!playTestState) && <Profile />}
        {(view === 'hunts' || !!playTestState) && <PastHunts />}
      </View>
    </View>
  );
};

export default Backpack;
